import { IRuleGroupService } from "../../service/evaluation/RuleGroupService";
import { IRuleGroup } from "../../model/evaluation/RuleGroup";

export default class UpdateRuleGroupInteractor {
  private ruleGroupService: IRuleGroupService;

  constructor(ruleGroupService) {
    this.ruleGroupService = ruleGroupService;
  }

  async execute(ruleGroup: IRuleGroup) {
    return this.ruleGroupService.updateRuleGroup(ruleGroup);
  }
}
